import { render, staticRenderFns } from "./zsk.vue?vue&type=template&id=e2f8d608&"
import script from "./zsk.vue?vue&type=script&lang=ts&"
export * from "./zsk.vue?vue&type=script&lang=ts&"
import style0 from "./zsk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports